import React from 'react';
import cnames from 'classnames';
import Helmet from 'react-helmet';
import NavBar from './NavBar/NavBar';
import MobileNavBar from './MobileNavBar/MobileNavBar';

import defaultShareImage from '../assets/images/default-share-image.jpg';

import styles from './Layout.module.scss';
class Layout extends React.Component {
  render() {
    const { children, location: { pathname }, className } = this.props;

    return (
      <div className={cnames(className)}>
        <Helmet
          titleTemplate="%s | Marxism 2020"
          defaultTitle="Marxism 2020"
        >
          {/* <link rel="icon" type="image/png" href="/assets/favicon-16.png" sizes="16x16" />
          <link rel="icon" type="image/png" href="/assets/favicon-32.png" sizes="32x32" /> */}
          <link rel="icon" type="image/png" href="/assets/favicon-96.png" sizes="96x96" />
          {/* <link rel="apple-touch-icon" href="/assets/apple-touch-icon-120.png" /> */}
          <meta property='twitter:card' content="summary_large_image" />
          <meta property='twitter:image:src' content={defaultShareImage} />
          <meta property='og:title' content='Marxism 2020' />
          <meta property='og:description' content='Marxism is the biggest annual conference of the far left in Australia. Every year hundreds of activists come together to discuss socialist politics to change the world.' />

          <meta property='og:type' content='website' />
          <meta property='og:image' content={defaultShareImage} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property='twitter:card' content="summary_large_image" />
          <link href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i" rel="stylesheet" />
          <link href="https://fonts.googleapis.com/css?family=Barlow+Condensed:400,400i,500,700,700i&display=swap" rel="stylesheet" />
        </Helmet>

        <NavBar className={styles.navbar} />

        <MobileNavBar className={styles.mobileNav} location={pathname} />

        { children }

      </div>
    );
  }
};

export default Layout;
